// extracted by mini-css-extract-plugin
module.exports = {"search-results-page-btn":"search-results-page-btn_Lnm-b"};